import React from 'react';
import FailureComponent from '../features/payment/components/FailureComponent';

const FailurePage = () => {
  return <FailureComponent />;
};

export default FailurePage;
